import { render, staticRenderFns } from "./ManageSnoozeNotifications.vue?vue&type=template&id=220e20d0&scoped=true&lang=pug"
import script from "./ManageSnoozeNotifications.vue?vue&type=script&lang=js"
export * from "./ManageSnoozeNotifications.vue?vue&type=script&lang=js"
import style0 from "./ManageSnoozeNotifications.vue?vue&type=style&index=0&id=220e20d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e20d0",
  null
  
)

export default component.exports